module.exports = __webpack_public_path__ + "img/Logo_RMC_2002.a76e843e.svg";